export const IDF_CERTIFICATE_QUIZ = '11318';
